import { createSlice } from "@reduxjs/toolkit";

export const INITIAL_STATE = {
  previousReports: [],
  isLoadingReports: false,
  isSubmitting: false,
};

const shreddingHomeSlice = createSlice({
  name: "home",
  initialState: INITIAL_STATE,
  reducers: {
    setPreviousReports(state, { payload }) {
      state.previousReports = payload || [];
    },
    setIsLoadingReports(state, { payload }) {
      state.isLoadingReports = Boolean(payload);
    },
    setIsSubmitting(state, { payload }) {
      state.isSubmitting = Boolean(payload);
    },
    deleteReport: (state, action) => {
      state.previousReports = state.previousReports.filter(
        (report) => report.reportId !== action.payload
      );
    },
    updateReportName: (state, { payload: { reportId, name } }) => {
      state.previousReports = state.previousReports.map((report) =>
        report.reportId === reportId ? { ...report, name } : report
      );
    },
  },
});

export const {
  setPreviousReports,
  setIsLoadingReports,
  setIsSubmitting,
  deleteReport,
  updateReportName,
} = shreddingHomeSlice.actions;

export default shreddingHomeSlice;
